// @ts-strict-ignore
import * as React from 'react';
import { ActionsPopoverReact } from 'common/widgets/actions-popover';
import { SvgIconReact } from 'common/components/svg-icon';
import type { PopoverParams } from 'common/report/insights/util/chart';
import styles from './index.module.styl';
export function StepsChartPopover(props: {
  popoverParams: PopoverParams;
}) {
  var _popoverParams$slotte;
  const popoverParams = props.popoverParams;
  if (!popoverParams.open) {
    return null;
  }
  return <ActionsPopoverReact buttonOptions={popoverParams.buttonOptions} className={styles.actionPopover} isSegmented={popoverParams.isSegmented} open={popoverParams.open} preventCloseSelectors={["div.bar", "div.drop-off-bar"]} style={popoverParams.styles} title={popoverParams.title} onAction={popoverParams.onAction} onClose={popoverParams.onClose} data-sentry-element="ActionsPopoverReact" data-sentry-component="StepsChartPopover" data-sentry-source-file="mixins.tsx">
      <div>
        <div className={styles.popoverContentWrapper}>
          {(_popoverParams$slotte = popoverParams.slottedContent) === null || _popoverParams$slotte === void 0 ? void 0 : _popoverParams$slotte.map(content => <div className={styles.popoverContentRow} key={content.text}>
              <div className={styles.popoverContentIcon}>
                {popoverParams.isDropOff ? <div className={styles.dropOffIcon}>
                    <SvgIconReact icon={"circle-decrease"} />
                  </div> : <div className={styles.communityIcon}>
                    <SvgIconReact icon={"community"} />
                  </div>}
              </div>
              <div className='popover-content-text-wrapper'>
                <div className={styles.popoverSlot}>
                  <div className={styles.popoverContentText}>{content.text}</div>
                  {content.subTextLines.map(line => <div className={styles.popoverContentSubtext} key={line}>
                      {line}
                    </div>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </ActionsPopoverReact>;
}